import { Avatar, Button, CssBaseline, TextField, FormControlLabel, Checkbox, Link, Grid, Box, Typography, Container, IconButton, InputAdornment, Modal, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import UserContext from '../../Context/User/userContext.jsx';

const theme = createTheme({
    palette: {
        primary: {
            main: '#556cd6',
        },
        secondary: {
            main: '#178383',
        },
    },
});

const Login = ({ setShowSpinner }) => {

    const { user, setUser } = useContext(UserContext);
    const userObj = user && (typeof user == "string" ? JSON.parse(user) : user);
    const navigate = useNavigate()
    useEffect(() => {
        if (userObj && userObj.signedDocument !== "") {
            navigate("/home")
        } else if (userObj && userObj.signedDocument === "") {
            navigate("/authentication")
        }
    }, [user, navigate, userObj]);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [forgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");

    const handlePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const reset = () => {
        setEmail('');
        setPassword('');
    }

    const handleLogin = (e) => {
        setShowSpinner(true);
        // Your login logic here
        e.preventDefault()
        const user = {
            email,
            password
        }
        // https://research-mate-b35a10757d5a.herokuapp.com/
        axios.post('https://research-mate-b35a10757d5a.herokuapp.com/api/auth/login', user)
            .then(res => {
                if (!res.data.user.approvedByAdmin && res.data.user.signedDocument) {
                    Swal.fire({
                        icon: "error",
                        title: "Not Approved...",
                        text: "Your request has not been approved by admin",
                        customClass: {
                            container: 'swal2-container-custom'
                        }
                    });
                } else {
                    setUser(res.data.user)
                    localStorage.setItem('user', JSON.stringify(res.data.user))
                    localStorage.setItem('token', JSON.stringify(res.data.token))
                    // Reset the form after successful submission
                }
                reset();
            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
            })
            .finally(() => {
                setShowSpinner(false);
            })
    };

    const handleForgotPassword = () => {
        setForgotPasswordModalOpen(true);
    };

    const handleCloseForgotPasswordModal = () => {
        setForgotPasswordModalOpen(false);
    };

    const handleSendRecoveryEmail = () => {
        setShowSpinner(true);
        // Your logic to send recovery email
        handleCloseForgotPasswordModal();
        axios.post('https://research-mate-b35a10757d5a.herokuapp.com/api/auth/forgetPassword', { email: forgotEmail })
            .then(res => {
                Swal.fire({
                    icon: "success",
                    title: "Sent...",
                    text: res.data.message,
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
                setShowSpinner(false);
                setForgotEmail("");
            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
                setForgotEmail("");
                setShowSpinner(false);
            })
    };
    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handlePasswordVisibility}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {/* <FormControlLabel
                            control={<Checkbox value="remember" color="primary" />}
                            label="Remember me"
                        /> */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            style={{backgroundColor:'#178383'}}
                        >
                            Sign In
                        </Button>
                        <Grid container>
                            <Grid item xs>
                                <Link href="#" sx={{color:'#169a8f',textDecoration:'none'}} variant="body2" onClick={handleForgotPassword}>
                                    Forgot password?
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link sx={{color:'#169a8f',textDecoration:'none'}}  href="/signin" variant="body2">
                                    {"Don't have an account? Sign Up"}
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Container>
            {/* Forgot Password Modal */}
            <Modal
                open={forgotPasswordModalOpen}
                onClose={handleCloseForgotPasswordModal}
                aria-labelledby="forgot-password-modal-title"
                aria-describedby="forgot-password-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography variant="h6" id="forgot-password-modal-title" gutterBottom>
                        Forgot Password
                    </Typography>
                    <Typography variant="body1" id="forgot-password-modal-description" gutterBottom>
                        Please enter your email address below to receive instructions on how to reset your password.
                    </Typography>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="forgot-password-email"
                        label="Email Address"
                        name="forgot-password-email"
                        autoComplete="email"
                        autoFocus
                        value={forgotEmail}
                        onChange={e => setForgotEmail(e.target.value)}
                    />
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleSendRecoveryEmail}
                        style={{backgroundColor:'#178383'}}
                    >
                        Send Recovery Email
                    </Button>
                </Box>
            </Modal>
        </ThemeProvider>
    );
};

export default Login;
